jQuery.noConflict();
var is_ie_lt9 = false;
var is_ie_lt7 = false;
var is_mobile = false;
(function($,sr){
	  var debounce = function (func, threshold, execAsap) {
	      var timeout;
	      return function debounced () {
	          var obj = this, args = arguments;
	          function delayed () {
	              if (!execAsap)
	                  func.apply(obj, args);
	              timeout = null;
	          };
	          if (timeout)
	              clearTimeout(timeout);
	          else if (execAsap)
	              func.apply(obj, args);
	          timeout = setTimeout(delayed, threshold || 100);
	      };
	  }
	  // smartresize 
	  jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };
	})(jQuery,'smartresize');
	jQuery(window).smartresize(function(){
	  var wh=jQuery(window).height();
	  var ww=jQuery(window).width();
	  if(ww<=1280){
	    var wr=(ww*100)/1280;
	  } else{
	    wr=100;
	  }
	  var bs=wr*2.55;
	  jQuery(".liquide").animate({"height":bs});
});

jQuery(document).ready(function(){

	var ww=jQuery(window).width();
	if(ww<=1280){
		var wr=(ww*100)/1280;
	} else {
	  wr=100;
	}
	var bs=wr*2.55;
	jQuery(".liquide").animate({"height":bs});	
	
    if(jQuery('#container_plan_site').css('display')=='none') {
        is_mobile = true;       
    }



    
  /*RESIZE IMAGE VIGNETTE*/
  if (jQuery('.vignette').length ) {
    jQuery('.vignette').resizeToParent();
  }
  if (jQuery('body.article div.photo').length ) {
    jQuery('body.article div.photo img').resizeToParent();
  }
  if (jQuery('body.petiteannonce div.photo').length ) {
	    jQuery('body.petiteannonce div.photo img').resizeToParent();
  }
  if (jQuery('body.evenement div.photo').length ) {
    jQuery('body.evenement div.photo img').resizeToParent();
  }
  if (jQuery('body.annuaireksup div.photo').length ) {
	    jQuery('body.annuaireksup div.photo img').resizeToParent();
  }
  if (jQuery('body.annuaireksup div.photo').length ) {
	    jQuery('body.annuaireksup div.photo img').resizeToParent();
}
  
 if (jQuery('#sliderArticles').length ) {
    jQuery('#sliderArticles .vignette_deco4 img').resizeToParent();
  }
 
 //POPUP AGRANDISSEMENT AUTOMATIQUE DES IMAGES INSEREES DANS LE CORPS DES ACTU /ARTICLE / STRUCTURE / ASSO / EVENEMENT
 if (jQuery('.actualite #description img').length ) { 
	 jQuery(".actualite #description img").each(function(){ 
  		 if ( ( jQuery(this).parent().prop("tagName") != "A" ) && ( jQuery(this).parent().attr('class') != "style1_media_vignette" ) && ( jQuery(this).parent().parent().prop("tagName") != "A" ) ) { 
		    jQuery(this).wrap( "<a href=\""+jQuery(this).attr('src')+"\" title=\""+jQuery(this).attr('alt')+"\" class=\"image-popup-no-margins\"></a>" );
		 }
	 });
 }

 if (jQuery('.article #description img').length ) { 
	 jQuery(".article #description img").each(function(){ 
  		 if ( ( jQuery(this).parent().prop("tagName") != "A" ) && ( jQuery(this).parent().attr('class') != "style1_media_vignette" ) && ( jQuery(this).parent().parent().prop("tagName") != "A" ) ) { 
	  	     jQuery(this).wrap( "<a href=\""+jQuery(this).attr('src')+"\" title=\""+jQuery(this).attr('alt')+"\" class=\"image-popup-no-margins\"></a>" );
		 }
	 });
 }
 if (jQuery('.evenement #description img').length ) { 
  	 jQuery(".evenement #description img").each(function(){ 
  		 if ( ( jQuery(this).parent().prop("tagName") != "A" ) && ( jQuery(this).parent().attr('class') != "style1_media_vignette" ) && ( jQuery(this).parent().parent().prop("tagName") != "A" ) ) { 
  	  	     jQuery(this).wrap( "<a href=\""+jQuery(this).attr('src')+"\" title=\""+jQuery(this).attr('alt')+"\" class=\"image-popup-no-margins\"></a>" );
  		 }
  	 });
}
 if (jQuery('.defaultstructureksup .motif img').length ) { 
	 jQuery(".defaultstructureksup .motif img").each(function(){ 
  		 if ( ( jQuery(this).parent().prop("tagName") != "A" ) && ( jQuery(this).parent().attr('class') != "style1_media_vignette" ) && ( jQuery(this).parent().parent().prop("tagName") != "A" ) ) { 
			 jQuery(this).wrap( "<a href=\""+jQuery(this).attr('src')+"\" title=\""+jQuery(this).attr('alt')+"\" class=\"image-popup-no-margins\"></a>" );
		 }
	 });
 }
 if (jQuery('.associationetudiant .element_deco img').length ) { 
	 jQuery(".associationetudiant .element_deco img").each(function(){ 
  		 if ( ( jQuery(this).parent().prop("tagName") != "A" ) && ( jQuery(this).parent().attr('class') != "style1_media_vignette" ) && ( jQuery(this).parent().parent().prop("tagName") != "A" ) ) { 
			 jQuery(this).wrap( "<a href=\""+jQuery(this).attr('src')+"\" title=\""+jQuery(this).attr('alt')+"\" class=\"image-popup-no-margins\"></a>" );
		 }
	 });
 }

//MENU PRINCIPAL
  //jQuery('#cssmenu > ul').prepend('<li class="mobile"><a href="#"><span>Menu <i class="fa fa-bars"></i></span></a></li>');
  jQuery('#cssmenu > ul > li > a').on('click touchstart', function(e) { 
    jQuery('#cssmenu li').removeClass('active');
    if (jQuery('.activefrom').length ) {
       jQuery('#cssmenu li').removeClass('activefrom');
    }
    jQuery(this).closest('li').addClass('active'); 
    var checkElement = jQuery(this).next();
    if((checkElement.is('ul')) && (checkElement.is(':visible'))) {
      jQuery(this).closest('li').removeClass('active');
      checkElement.slideToggle('normal');
      jQuery('#cssmenu > ul > li.active:after').css("display","none");
    }
    if((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
      jQuery('.niv1 button').css("display","block");
      jQuery('#cssmenu ul ul:visible').slideUp(200);
      checkElement.slideDown(500);
    }
    if( jQuery(this).parent().hasClass('mobile') ) {
      e.preventDefault();
      jQuery('#cssmenu').toggleClass('expand');
      if ( (jQuery(this).parent().hasClass("active")) && (!jQuery('#cssmenu ul li.has-sub ul').is(':visible'))  ){
          jQuery(this).parent().removeClass('active');
      }
     // jQuery(this).closest('li').removeClass('active');
    }
    if(jQuery(this).closest('li').find('ul').children().length == 0) {
      return true;
    } else {
      return false; 
    }   
  });

  jQuery('.niv1 button').click(function () {
    jQuery('#cssmenu ul ul:visible').slideUp(500);
      jQuery('#cssmenu > ul > li.active').removeClass('active');
   });

  //FERMETURE DU MENU LORS DU CLICK EN DEHORS
  jQuery(document).bind('click', function(e) {
    var jQueryclicked = jQuery(e.target);
    if (! jQueryclicked.parents().hasClass("active")  ) {
      if (! jQuery("div#cssmenu").hasClass("expand")) {
        jQuery('#cssmenu ul li.has-sub ul:visible').hide();
      }
      jQuery('#cssmenu > ul > li.active').removeClass('active');
    }
    if (! jQueryclicked.parents().parents().parents().hasClass("expand")) {
        jQuery('div#cssmenu.expand').removeClass('expand');
      }
  });

//FLEXSLIDER
  if  (is_ie_lt9==true){
    containerFlexSlider = ".flexslider";
  } else {
    containerFlexSlider = ".numSlide";
  }

  jQuery('.flexslider').flexslider({
    animation:'fade',
    //direction:'vertical',
    //controlNav:'thumbnails',
    controlsContainer:  containerFlexSlider,
    controlNav: false,
    slideshow:true,
    slideshowSpeed:7000,
    animationSpeed:700,
    useCSS:true,
    smoothHeight:true,
    pauseOnHover:true,
    mousewheel:false,
    multipleKeyboard:true,
    prevText: " << Pr&eacute;c&eacute;dent",           //String: Set the text for the "previous" directionNav item
    nextText: "Suivant >>",               //String: Set the text for the "next" directionNav item
    pausePlay: false,               //Boolean: Create pause/play dynamic element
    pauseText: 'Pause',             //String: Set the text for the "pause" pausePlay item
    playText: 'Jouer',
    start: function(slider) {

    	jQuery.flexloader(slider, {
            'background_images': true,
            'class_name': 'flexloader-custom-class-background-image-loaded'
          });

     jQuery('.currentSlide').text(slider.currentSlide+1);
     jQuery('.totalSlides').text(slider.count);
    },
    after: function(slider) {
		jQuery.flexloader(slider, {
            'background_images': true,
            'class_name': 'flexloader-custom-class-background-image-loaded'
        });
        jQuery('.currentSlide').text(slider.currentSlide+1);
      }
  });
  if (is_mobile){
    jQuery(".flex-container .flexslider .slides li").css("background-image","");
    jQuery(".visuel-rubrique").css("background-image","none");

  }

  //TRAITEMENT DU BACKGROUND 100% 
  jQuery(".slides li").css( "background-size", "cover" );
 // jQuery("div.visuel-rubrique").css({backgroundSize: "cover"});

  //Execution du lazy loading lors du changement de page de la galerie media
  jQuery(".pagination_droite.pagination_suivant a").click(function () {
      jQuery(".pagination_contenu img.lazy")
      .lazyload({
        event: "lazyload"
      })
      .trigger("lazyload");
  });

  //SLIDER SIMPLE
  if (jQuery('#sliderArticles').length ) {
	  
	  jQuery('#sliderArticles').bxSlider({
	    slideWidth: 330,
	    minSlides: 4,
	    maxSlides: 4,
	    slideMargin: 15
	  });
	 
	  //APPARITION DU SLIDER
	  jQuery( "#sliderArticles").css('visibility','visible');
	  jQuery( ".bx-loading").remove();
  }
  
  
  
  /*MAGNIFIQUE POPUP*/
  if (jQuery('.image-popup-no-margins').length ) {
    jQuery('.image-popup-no-margins').magnificPopup({ 
      type: 'image',
      mainClass: 'mfp-with-zoom', // this class is for CSS animation below

      zoom: {
        enabled: false, // By default it's false, so don't forget to enable it

        duration: 300, // duration of the effect, in milliseconds
        easing: 'ease-in-out', // CSS transition easing function 

        // The "opener" function should return the element from which popup will be zoomed in
        // and to which popup will be scaled down
        // By defailt it looks for an image tag:
        opener: function(openerElement) {
          // openerElement is the element on which popup was initialized, in this case its <a> tag
          // you don't need to add "opener" option if this code matches your needs, it's defailt one.
          return openerElement.is('img') ? openerElement : openerElement.find('img');
        }
      }

    });
  }


  //CLIC/TOUCH RECHERCHE
  jQuery(".sb-icon-search").click(function() {
    if ( ( jQuery(".sb-search-open").length ) && (jQuery.trim(jQuery("#MOTS_CLEFS").val()).length > 0) ){
      jQuery("form#recherche_simple").submit();
    }
  });

  jQuery('#sb-search').magnificPopup({
	  items: {
	      src: '#recherche-simple',
	      type: 'inline'
	  },
	    focus: '#default-MOTS_CLEFS',  
	});
  
  if (jQuery('.recherche form#recherche_avancee #TYPE_DOCUMENT').length ) { 
  jQuery('.recherche form#recherche_avancee #TYPE_DOCUMENT option').each(function() { 
	     var myOption = jQuery(this).text();
	     var myPos= myOption.indexOf("{");
	    if ( myPos >= 0 ) {
	      jQuery(this).remove();
	    }
	   });
  }
  if (jQuery('.recherche form#recherche_avancee #THEMATIQUE').length ) { 
	  jQuery('.recherche form#recherche_avancee #THEMATIQUE option').each(function() { 
	     var myOption = jQuery(this).text();
	     var myPos= myOption.indexOf("{");
	    if ( myPos >= 0 ) {
	      jQuery(this).remove();
	    }
	   });
  }
  if (jQuery('.extension-agenda__requeteur #THEMATIQUE').length ) { 
	  jQuery('.extension-agenda__requeteur #THEMATIQUE option').each(function() { 
		     var myOption = jQuery(this).text();
		     var myPos= myOption.indexOf("{");
		    if ( myPos >= 0 ) {
			   jQuery(this).css("display","none");
		    }
		   });
  }
  //SUPPRESSION DES LIBELLES {intranet} EN SAISIE FRONT POUR LES TYPES D'ACTU
  if (jQuery('#form_saisie_front .saisieActualite__type li').length ) {
	  jQuery('#form_saisie_front .saisieActualite__type li').each(function() { 
		     var myOption = jQuery(this).children("label").text();
		     var myPos= myOption.indexOf("{");
		    if ( myPos >= 0 ) {
			      jQuery(this).css("display","none");
		    }
	   });
  }
  
  //SUPPRESSION DES LIBELLES SUR FORMULAIRE SAISIE FRONT POUR LES THEMATIQUES
  if (jQuery('#form_saisie_front #kmultiselectTHEMATIQUE .k-multiselect-parent .kscrollable li').length ) {
	  jQuery('#form_saisie_front #kmultiselectTHEMATIQUE .k-multiselect-parent .kscrollable li').each(function() { 
		     var myOption = jQuery(this).attr("title");
		     var myPos= myOption.indexOf("{");
		    if ( myPos >= 0 ) {
		      jQuery(this).remove();
		    }
	   });
  }
  //SUPPRESSION DES LIBELLES SUR FORMULAIRE SAISIE FRONT POUR LES THEMATIQUES D'EVENEMENT
  if (jQuery('#form_saisie_front #kmultiselectAGENDAEVT_THEMATIQUE .k-multiselect-parent .kscrollable li').length ) {
	  jQuery('#form_saisie_front #kmultiselectAGENDAEVT_THEMATIQUE .k-multiselect-parent .kscrollable li').each(function() { 
		     var myOption = jQuery(this).attr("title");
		     var myPos= myOption.indexOf("{");
		    if ( myPos >= 0 ) {
		      jQuery(this).remove();
		    }
	   });
  }

  //SUPPRESSION DES LIBELLES ENTRE {} SUR LES FICHES ANNUAIRE POUR LES DISCIPLINE
  if (jQuery('.annuaireksup .discipline .motif__contenu').length ) {
	  jQuery('.annuaireksup .discipline .motif__contenu').each(function() { 
		    var myOption = jQuery(this).text();
		    var myPos= myOption.indexOf("{");
		    var myPos2= myOption.indexOf("}");
		    if ( myPos >= 0 && myPos2 >= 0 ) {
		    	jQuery(this).text(jQuery(this).text().replace( /{\/?[\w]+}/g, ''));
		    }
	   });
  }
  
  
  //SCROLL TO TOP
  jQuery(window).scroll(function(){
    if (jQuery(this).scrollTop() > 100) {
      jQuery('.scrollup').fadeIn();
    } else {
      jQuery('.scrollup').fadeOut();
    }
  }); 

  jQuery('.scrollup').click(function(){
    jQuery("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });







  //MENU LANGUE
  jQuery("#menu_langues .dropdown dt a").click(function() {
    jQuery("#menu_langues .dropdown dd ul").toggle();
  });
                        
  jQuery("#menu_langues .dropdown dd ul li a").click(function() {
    var text = jQuery(this).html();
    jQuery("#menu_langues .dropdown dt a span").html(text);
    jQuery("#menu_langues .dropdown dd ul").hide();
  });
                        
  jQuery(document).bind('click', function(e) {
    var jQueryclicked = jQuery(e.target);
    if (! jQueryclicked.parents().hasClass("dropdown"))
      jQuery("#menu_langues .dropdown dd ul").hide();
   });

  //MENU VOUS ETES
  jQuery("#menu_vousetes_small .dropdown dt a").click(function() {
	    jQuery("#menu_vousetes_small .dropdown dd ul").toggle();
	  });
	                        
	  jQuery("#menu_vousetes_small .dropdown dd ul li a").click(function() {
	    var text = jQuery(this).html();
	    jQuery("#menu_vousetes_small .dropdown dt a span").html(text);
	    jQuery("#menu_vousetes_small .dropdown dd ul").hide();
	  });
	 //FERMETURE 
	jQuery(document).bind('click', function(e) {
	  var jQueryclicked = jQuery(e.target);
	  if (! jQueryclicked.parents().hasClass("dropdown"))
	    jQuery("#menu_vousetes_small .dropdown dd ul").hide();
	  });

  //MOTEUR DE RECHERCHE SIMPLE
  jQuery( "#MOTS_CLEFS" ).focus(function() {
    jQuery( "form#recherche_simple .btn").fadeIn();
  });
  jQuery( "#MOTS_CLEFS" ).focusout(function() {
    jQuery( "form#recherche_simple .btn").css("display","none");
  });





  //PAGE ACTU, FILTRAGE LISTE DE TYPE D'ACTU
  //////////////////////////////////////////

  jQuery("#typeActu option").each(function(){ 
    var libelleOption = jQuery(this).text();
    var valeurOption = jQuery(this).val();
    var nbreOccurence = jQuery(".avec_vignette_ajax."+ valeurOption).length; 
    var myPos1= libelleOption.indexOf("}");
    if (myPos1 > 0){
    libelleOption = libelleOption.substring(myPos1+1, libelleOption.length);
    }    
    if (valeurOption != "ALL"){
      if (nbreOccurence == 0 ){
       // alert(libelleOption + " " +valeurOption + " " +nbreOccurence)
        jQuery(this).remove();
      } else {
        jQuery(this).text(libelleOption + " ("+nbreOccurence+ ")");  
      }
    }
   // jQuery(this).attr('src','/jspWWW/scripts/lazyload/load.jpg');
  });


  //Filtrage des actu via le type
  jQuery("#typeActu").change(function() {
    var valeur= jQuery(this).val();
    var aMasquer = jQuery(".avec_vignette_ajax");
    var aAfficher = jQuery("."+ valeur);
    jQuery("#resetFiltre").fadeOut( "fast" ); 
    if (valeur== "ALL"){
     aMasquer.fadeIn( "slow" ); 
    } else {
      aMasquer.fadeOut( "fast" ); 
      aAfficher.fadeIn( "slow" ); 
    }
    jQuery(".vignette_deco img.lazy")
    .lazyload({
      event: "lazyload",
      effect: "fadeIn"
    })
    .trigger("lazyload");
  });

  
  //CLICK SUR TYPE ACTU
  if ( is_mobile == false ){
    jQuery(".avec_vignette_ajax .type_vignette_deco").click(function () {
      jQuery(".vignette_deco img.lazy")
      .lazyload({
        event: "lazyload",
        effect: "fadeIn"
      })
      .trigger("lazyload");
      var classeaAfficher = jQuery(this).attr('class');
      var classes = jQuery(this).attr('class');
      jQuery(".avec_vignette_ajax").fadeOut( "fast" ); 
      jQuery("#resetFiltre").fadeIn( "slow" ); 
      jQuery(".avec_vignette_ajax .type_vignette_deco").each(function(){ 
        if (jQuery(this).hasClass(classes)) {
          jQuery(this).parent().fadeIn( "slow" ); 
        } 
      });
    });
  }

 //RESET FILTRE TYPE ACTU
 jQuery("#resetFiltre").click(function () {
   jQuery(".avec_vignette_ajax").fadeIn( "slow" ); 
   jQuery("#resetFiltre").fadeOut( "fast" ); 
   jQuery('#typeActu').prop('selectedIndex',0);
 });
 //////////////////////////////////////////




  //PAGE FOCUS, FILTRAGE LISTE DE THEMATIQUE
  //////////////////////////////////////////
 if (jQuery('#thematiqueFocus').length ) { 
  jQuery("#thematiqueFocus option").each(function(){ 
    var libelleOption = jQuery(this).text();
    var valeurOption = jQuery(this).val();
    var nbreOccurence = jQuery(".avec_vignette_ajax."+ valeurOption).length; 
    var myPos1= libelleOption.indexOf("}");
    if (myPos1 > 0){
    libelleOption = libelleOption.substring(myPos1+1, libelleOption.length);
    }
    if (valeurOption != "TOUS"){
      if (nbreOccurence == 0 ){
       // alert(libelleOption + " " +valeurOption + " " +nbreOccurence)
        jQuery(this).remove();
      } else {
        jQuery(this).text(libelleOption + " ("+nbreOccurence+ ")");  
      }
    }
  });
//Filtrage des actu via le type
  jQuery("#thematiqueFocus").change(function() {
    var valeur= jQuery(this).val();
    var aMasquer = jQuery(".avec_vignette_ajax");
    var aAfficher = jQuery("."+ valeur);
    jQuery("#resetFiltre").fadeOut( "fast" ); 
    if (valeur== "TOUS"){
     aMasquer.fadeIn( "slow" ); 
    } else {
      aMasquer.fadeOut( "fast" ); 
      aAfficher.fadeIn( "slow" ); 
    }
    jQuery(".vignette_deco img.lazy")
    .lazyload({
      event: "lazyload",
      effect: "fadeIn"
    })
    .trigger("lazyload");
  });
 }
  //CLICK SUR THEMATIQUE FOCUS
  if ( is_mobile == false ){
    jQuery(".avec_vignette_ajax .type_vignette_deco").click(function () {
      jQuery(".vignette_deco img.lazy")
      .lazyload({
        event: "lazyload",
        effect: "fadeIn"
      })
      .trigger("lazyload");
      var classeaAfficher = jQuery(this).attr('class');
      var classes = jQuery(this).attr('class');
      jQuery(".avec_vignette_ajax").fadeOut( "fast" ); 
      jQuery("#resetFiltre").fadeIn( "slow" ); 
      jQuery(".avec_vignette_ajax .type_vignette_deco").each(function(){ 
        if (jQuery(this).hasClass(classes)) {
          jQuery(this).parent().fadeIn( "slow" ); 
        } 
      });
    });
  }

 //RESET FILTRE TYPE ACTU
 jQuery("#resetFiltre").click(function () {
   jQuery(".avec_vignette_ajax").fadeIn( "slow" ); 
   jQuery("#resetFiltre").fadeOut( "fast" ); 
   jQuery('#thematiqueFocus').prop('selectedIndex',0);
 });
  //////////////////////////////////////////
 if (jQuery('.avec_vignette_ajax .voirPlus').length ) {
 jQuery(".avec_vignette_ajax .voirPlus").each(function(){ 
    var curHeight = jQuery(this).prev().height();
    var curRealHeight = jQuery(this).prev().css("height", "auto").height();
    jQuery(this).prev().css("height", curHeight);
    if ( curHeight >= curRealHeight) {
      jQuery(this).prev().css("height", curHeight+30);
      jQuery(this).css("display", "none");
      jQuery(this).parent().children().first().css("display", "none");
    }
  });
 }
 
 //PROTECTION NUMERO DE TELEPHONE PETITES ANNONCES
 if (jQuery('body.petiteannonce a#lnt').length ) {
		 jQuery('body.petiteannonce a#lnt').attr("href", "tel:"+jQuery('body.petiteannonce a#lnt').attr('data-original').replace(/ /g,'') );
		 jQuery('body.petiteannonce #nt').html( jQuery('body.petiteannonce a#lnt').attr('data-original') );
 }
 
 	//DEPLACEMENT DES BLOCS "encadre_auto_fiche" EN HAUT DE LA ZONE D'ENCADRE
	if (jQuery("body.articleblog .encadre_auto_fiche.blog-description").length && jQuery("#encadres .numero--1").length ) {
		 jQuery(".encadre_auto_fiche.blog-description").insertBefore("#encadres .numero--1");
	}
	if ( jQuery("body.articleblog .encadre_auto_fiche.blog-derniers-articles").length && jQuery("#encadres .numero--1").length ) {
		 jQuery(".encadre_auto_fiche.blog-derniers-articles").insertBefore("#encadres .numero--1");
	}
	if (jQuery("body.blog .encadre_auto_fiche.blog-description").length && jQuery("#encadres .numero--1").length ) {
		 jQuery(".encadre_auto_fiche.blog-description").insertBefore("#encadres .numero--1");
	}
	if ( jQuery("body.blog .encadre_auto_fiche.blog-derniers-articles").length && jQuery("#encadres .numero--1").length ) {
		 jQuery(".encadre_auto_fiche.blog-derniers-articles").insertBefore("#encadres .numero--1");
	}

 //NUAGE DE TAG EN BAS DE PAGE
 if (jQuery('#cloud-keywords button').length ) {
  jQuery("#cloud-keywords button").each(function(){ 
    var objet = "";
    var kw = "";
    var rh = "";
    var ln = "";
    var rs = "";
    var allClasses = "";
    var url = "/search?beanKey=";
    
    jQuery(this).click(function() {
      objet = jQuery(this).attr('class').split(' ')[0];
      rh = jQuery(this).attr('class').split(' ')[1];
      ln = jQuery(this).attr('class').split(' ')[2];
      rs = jQuery(this).attr('class').split(' ')[3];
      allClasses = jQuery(this).attr('class').split(" ").length - 1;

      if ( allClasses > 4 ){
        for (var i = 4; i<=allClasses; i++) {
          kw = kw + " " + jQuery(this).attr('class').split(' ')[i];

        }
      } else {
          kw = jQuery(this).attr('class').split(' ')[4];
      }

      //alert("&RH="+rh+"&LANGUE="+ln+"&CODE_RUBRIQUE="+rs+"&QUERY="+kw);
      window.location.href = url + "&RH="+rh+"&l="+ln+"&q="+kw;
      return false;
    });
  });
 }

  jQuery("img.lazy").lazyload({
      effect: "fadeIn",
      failure_limit : 7
  });
 
  //RECLASSEMENT ALPHABETIQUE DES FICHIERS JOINTS DES FICHES DOCUMENTS
  if (jQuery('.document .fichiers-joints li.fichiers-joints__item').length && jQuery(".document .fichiers-joints li.fichiers-joints__item").length > '1' &&  moment( jQuery( "meta[name='Date-Revision-yyyymmdd']" ).attr("content").slice(0, 8 ) ).isBefore('20220718') ) {
	  jQuery('ul.fichiers-joints').fadeOut( 0 ); 
	  tinysort('.document .fichiers-joints li.fichiers-joints__item');
	  jQuery('ul.fichiers-joints').fadeIn( "slow" ); 
  }
  
  //PAPAPARSE O2F
  if (jQuery('#odf_fst_all').length ) {
	  var content = Papa.parse(jQuery("#odf_fst_all")[0].innerHTML, papa_config);
	  jQuery("#odf_fst_all").html(render_odf(content, "Formations",["COMPOSANTE"],render_composante,["DIPLOME",,"MEN_ID","MEN_TITLE"],render_diplome,render_parcours));
  }

  //Deplacement Carte Gmap ou OpenStretMap au dessus du plan du site puis chargement de la carte OpenStreeMap si présente
  if (jQuery('.pagelibre #container_maps').length ) {
	  jQuery(".pagelibre #container_maps").insertBefore( "#container-plan-site");
	  jQuery(".pagelibre #container-container-plan-site").css("margin-top","0");
	  jQuery(".pagelibre #container_maps").toggle();
  }

  if (jQuery('#omap').length ) {
		map = new OpenLayers.Map("omap");
		map.addLayer(new OpenLayers.Layer.OSM());
		var lonLat = new OpenLayers.LonLat( jQuery("#LongitudeOL").val() , jQuery("#LatitudeOL").val() )
		.transform(
			 new OpenLayers.Projection("EPSG:4326"), // transform from WGS 1984
		     map.getProjectionObject() // to Spherical Mercator Projection
		);
		var zoom=jQuery("#ZoomOL").val();
		if (zoom.length === 0) {
			zoom = 17;
		}
	    var markers = new OpenLayers.Layer.Markers( "Markers" );
	    map.addLayer(markers);
	    markers.addMarker(new OpenLayers.Marker(lonLat));
	    map.setCenter (lonLat, zoom);
  }

  
  //OWN CAROUSEL
  jQuery(function () {
	  jQuery('.owl-carousel').each(function () {
	      let jQueryt = jQuery(this);
	      let willBeAnimated = jQueryt.find('.slideshow__item__wrapper').length > 1;
	      let isControl = "";

	      if ( jQuery(this).is("[control]") ){
		       isControl = jQuery(this).attr("control");
	      }else{
	    	   isControl = false;
	    	   jQuery( ".owl-nav " ).removeClass( "disabled" );
	      }
		     //console.log(isControl);      
	      let isAutoplay = jQueryt.attr("autoplay") && willBeAnimated;
	      let isAutoplayHoverPause = jQueryt.attr("autoplayHoverPause") && willBeAnimated;
	      let autoplayTimeoutAttr = jQueryt.attr("autoplayTimeout");
	      if (autoplayTimeoutAttr === '' || Number.isNaN(autoplayTimeoutAttr)) {
	        autoplayTimeoutAttr = 8000;
	      }
	      let smartSpeedAttr = jQueryt.attr("smartSpeed");
	      if (smartSpeedAttr === '' || Number.isNaN(smartSpeedAttr)) {
	        smartSpeedAttr = 200;
	      }
	      jQueryt.owlCarousel({
	        items: 1,
	        margin: 16,
	        loop: willBeAnimated,
	        nav: isControl,
	        dots: isControl,
	        autoplay: isAutoplay,
	        mouseDrag: willBeAnimated,
	        touchDrag: willBeAnimated,
	        autoplayTimeout: autoplayTimeoutAttr,
	        lazyLoad: true,
	        autoplayHoverPause: isAutoplayHoverPause,
	        smartSpeed: smartSpeedAttr,
	      });
	      jQueryt.find('.owl-controls').prepend('<button class="owl-prev">&lt;</button>').append('<button class="owl-next">&gt;</button>');
	      jQueryt.find('.owl-controls .owl-prev').click(function () {
	        jQueryt.trigger('prev.owl.carousel');
	      }).end().find('.owl-controls .owl-next').click(function () {
	        jQueryt.trigger('next.owl.carousel');
	      });
	    });
	  });
  
  
  
  
  //MOTEUR DE RECHERCHE INTREGRE SOUS FORME D'INCLUDE HTML DANS LES ZONES DE CONTENUS
  if (jQuery('#recherche_include').length ) {
	jQuery('#recherche_include input[name=CODE_RUBRIQUE]').val(jQuery('#recherche_simple input[name=CODE_RUBRIQUE]').val());;
	jQuery('#recherche_include input[name=RH]').val(jQuery('#recherche_simple input[name=RH]').val());;
  }
  //RESULTATS TABLEAUX PACES
  if (jQuery('#paces').length ) {
	  jQuery('#paces').css("width",( jQuery('.portlet-contenu').width() - 32 ) );
  }

  //INCLUDE HTML PERMETTANT D'OURVIR FERMER DES DIV AVEC ANIMATION ACCORDEON
  if (jQuery('.pagelibre [class^=accordion-solo-]').length ) {
		jQuery(".pagelibre [class^=accordion-solo-]").each(function(){ 
			jQuery(this).closest('[class^=paragraphe--]').wrapAll( "<div class='accordion-solo'>" );
			jQuery(this).closest('[class^=paragraphe__contenu--]').wrapAll( "<div class='accordion-container'>" );
			jQuery(this).parent().children('h2:first-child').insertBefore( jQuery(this).parent()  );
			jQuery( ".accordion-solo" ).accordion({
				header: "h2",
				collapsible: true,
				active: false,
				heightStyle:"content"
		  	  });
		});
  }
  
  
  //PORTLET RESEAUX SOCIAUX
  if (jQuery('div#rs').length ) {
	  //Repositionnement des vignettes
	  if (jQuery('img.vignette_rs').length ) {
	    jQuery('img.vignette_rs').resizeToParent();
	  }  
	  //Reclassement des posts par ordre chronologique 
	  if ( jQuery('div#rs div.rs_container').length  ) {
	     tinysort('div#rs div.rs_container',{data:'timestamp',order:'desc'});
	     jQuery('div#rs').fadeIn( "slow" );         
	   }

	   //Chargement d'Isotope (affichage façon mosaïque) 
	   var $grid = jQuery('.rs').isotope({
	     itemSelector: '.grid-item',
	     //layoutMode: 'fitRows',
	     masonry: {
	       //columnWidth: 16,
	       gutter: 25,
	       horizontalOrder: true,
           isFitWidth: true 
	     }
	   });
	   // filter functions
	   var filterFns = {};
	   // bind filter button click
	   jQuery('.rs_filters_button_group').on( 'click', 'button', function() {
	     var filterValue = $( this ).attr('data-filter');
	     // use filterFn if matches value
	     filterValue = filterFns[ filterValue ] || filterValue;
	     $grid.isotope({ filter: filterValue });
	   });
	   // change is-checked class on buttons
	   jQuery('.rs_button_group').each( function( i, buttonGroup ) {
	     var $buttonGroup = jQuery( buttonGroup );
	     $buttonGroup.on( 'click', 'button', function() {
	       $buttonGroup.find('.is-checked').removeClass('is-checked');
	       $( this ).addClass('is-checked');
	     });
	   });
  }  
  
  /*BUTTON  LYON1*/
  /*SUPPRESSION D'ESPACE INUTILE*/
   if (jQuery('div > .UL1button').length ) {
   	jQuery("div > .UL1button").each(function(){ 
	    	if ( jQuery(this).children().eq(1).prop("tagName") == "A" ) {
	    		jQuery(this).html(function (i, html) {
	    			return html.replace(/&nbsp;/g, '');
	    		});
	    	}
   	});
     }
	if (jQuery('p > .UL1button').length ) {
		jQuery("p > .UL1button").each(function(){ 
	    	if ( jQuery(this).children().eq(1).prop("tagName") == "A" ) {
	    		jQuery(this).html(function (i, html) {
	    			return html.replace(/&nbsp;/g, '');
	    		});
	    	}
		});
	}
  
	//Accessibilité : Raccourci clavier pour ouvrir le moteur de recherche
	var keys = {};
	jQuery(window).on("keyup keydown", function (e) {
		keys[e.which] = e.type === 'keydown';
	}).click(function () {
		//Alt + Maj + 5
		if (keys[16] && keys[18] && keys[53]) {
				jQuery.magnificPopup.open({
					items: {
						src: '#recherche-simple',
						type: 'inline'
							},
							focus: '#default-MOTS_CLEFS'  
				});
			    keys = {};
		}
	});		
	
	
});

//PARALAX SUR BANDEAU DE RUBRIQUE ET MENU
jQuery(window).scroll(function() {
var bandeauflash = 0;
if (jQuery('#bandeau_flash').length ) {
	bandeauflash = jQuery('#bandeau_flash').height();
}
var ajustement = 40+bandeauflash;
var ajustement2 = 215+bandeauflash;
var posMenu = jQuery('div.container-visuel-rubrique').offset().top + jQuery('div.container-visuel-rubrique').height();
var hauteurMinimumPage =  jQuery('#container-fil-ariane').height() + jQuery('#page').height() + jQuery('#container-plan-site').height()  + jQuery('#container_PC_nav').height() +  jQuery('#containerMenu').height();
var scrolledY = jQuery(window).scrollTop();

//BANDEAU
if (scrolledY >= ajustement) {
	jQuery('.visuel-rubrique').css('background-position', 'center ' + ((scrolledY-ajustement)) + 'px');
} else{
	jQuery('.visuel-rubrique').css('background-position', 'center 0px'); 
}

//MENU DOCK OU PAS
//transitionFor('#cssmenu > ul > li > a','line-height 1s');
//transitionFor('#cssmenu > ul > li > a','font-size 1s');
transitionFor('.sb-search form#recherche_simple','line-height 0.5s');
//transitionFor('.sb-search-input','height 0.5s');
transitionFor('.sb-search .sb-icon-search','line-height 0.5s');
transitionFor('#menu_langues .dropdown dt a','font-size 0.5s');
transitionFor('#menu_langues .picto-flag','max-height 0.5s');
transitionFor('#menu_langues .picto-flag','max-width 0.5s');
	
//alert( hauteurMinimumPage + " - " + jQuery(document).height() + " - "+jQuery(window).height() + " - " + posMenu + " - " + jQuery('#containerMenu').height() );

//alert(  hauteurMinimumPage + " - " +  jQuery(window).height());


//MENU DOCKED
if ( (scrolledY >= posMenu) && (hauteurMinimumPage > jQuery(window).height()) ) {
	jQuery('#containerMenu').css('position', 'fixed');
	jQuery('#containerMenu').addClass('docked');
	jQuery('#containerMenu').css('width', '100%');
	jQuery('#containerMenu').css('z-index', '9999');
	jQuery('#containerMenu').css('left', '0');
	jQuery('#containerMenu').css('top', '0');
	jQuery('#page').css('margin-top', '2rem');
	jQuery('#cssmenu > ul > li.mobile  > a').on('click touchstart', function(e) { 
   	  jQuery(window).scrollTop( jQuery('div.container-visuel-rubrique').offset().top + jQuery('div.container-visuel-rubrique').height() );
	});

	
	if (window.matchMedia("(min-width: 40em)").matches) {
		jQuery('#menu').css('height','auto');
		jQuery('#nav').css('height','2rem');
		
		jQuery('#cssmenu > ul > li.mobile').css('height','2rem');
		jQuery('#cssmenu > ul > li.mobile > a').css('line-height','2rem');	
		jQuery('#cssmenu > ul > li.mobile > a').css('height','2rem');	
		jQuery('#cssmenu > ul > li.mobile > a').css('font-size','0.9rem');	
		
		jQuery('#cssmenu > ul > li > a').addClass('mini');
				
		jQuery('#cssmenu > ul > li.active:after').css('display','none');	
		
		jQuery('#menu_vousetes_small').css('height','2rem');	
		jQuery('#menu_vousetes_small').css('font-size','0.7rem');	
		jQuery('#menu_vousetes_small .dropdown dd').css('padding-top','0');	
		jQuery('#menu_vousetes_small').css('line-height','0.7rem');
		jQuery('#menu_vousetes_small .dropdown dd').css('line-height','0.9rem');	
		jQuery('#menu_vousetes_small .dropdown dt a').css('font-size','0.8rem');	
		jQuery('#menu_vousetes_small .dropdown dt a span.titre_acces_direct').css('display','none');	
		jQuery('#menu_vousetes_small .dropdown dd ul').css('top','1px');
				
		jQuery('#menu_langues').css('height','2rem');	
		jQuery('#menu_langues .dropdown dt a').css('padding-top','0.2rem');	
		jQuery('#menu_langues .dropdown dt a').css('line-height','inherit');	
		jQuery('#menu_langues .dropdown dt a').css('font-size','0.7rem');	
		jQuery('#menu_langues .picto-flag').css('max-height','1rem');	
		jQuery('#menu_langues .picto-flag').css('max-width','1.3rem');		
		
		jQuery('.sb-search').css('height','2rem');	
		jQuery('.sb-search').css('line-height','2rem');	
		jQuery('.sb-search form#recherche_simple').css('line-height','2rem');	
		jQuery('.sb-icon-search').css('height','auto');	
		//jQuery('.sb-search-input').css('height','2rem');	
	} else {
		  if (jQuery('#cssmenu.expand').length ) {		
			  jQuery('#containerMenu').css('position', 'initial');
			}
		  //jQuery('#menu_vousetes_small .dropdown dd ul').css('top','4px');
	}
		
} else{
		jQuery('#containerMenu').css('position', 'initial');
		jQuery('#containerMenu').removeClass('docked');
		jQuery('#page').css('margin-top', '0');
	
		jQuery('#menu').css('height','3.5rem');
		jQuery('#nav').css('height','initial');
		jQuery('#cssmenu > ul > li.mobile').css('height','3.5rem');
		jQuery('#cssmenu > ul > li.mobile > a').css('height','auto');
		jQuery('#cssmenu > ul > li.mobile > a').css('line-height','3.5rem');	
		jQuery('#cssmenu > ul > li.mobile > a').css('font-size','1rem');	
		
		if (jQuery('#cssmenu > ul > li > a.mini').length ) {
			jQuery('#cssmenu > ul > li > a').removeClass('mini');
		}


		//jQuery('#cssmenu > ul > li > a ').css('display','block');	
		if (window.matchMedia("(min-width: 40em)").matches) {
			jQuery('#cssmenu > ul > li.active > a').css('display','initial');	
			jQuery('#menu_vousetes_small .dropdown dt a span.titre_acces_direct').css('display','initial');	
			//jQuery('#cssmenu > ul > li.not-yet > a').css('height','auto');
			//jQuery('#cssmenu > ul > li.not-yet > a').css('line-height','3.5rem');	
			//jQuery('#cssmenu > ul > li.not-yet > a').css('font-size','1.2rem');	
		}
		jQuery('#menu_langues').css('height','3.5rem');		
		jQuery('#menu_langues .dropdown dt a').css('padding-top','0.5rem');	
		jQuery('#menu_langues .dropdown dt a').css('line-height','1.65rem');	
		jQuery('#menu_langues .dropdown dt a').css('font-size','0.9rem');	
		jQuery('#menu_langues .picto-flag').css('max-height','1.4rem');	
		jQuery('#menu_langues .picto-flag').css('max-width','1.9rem');	

		jQuery('#menu_vousetes_small').css('height','3.5rem');	
		jQuery('#menu_vousetes_small').css('font-size','0.9rem');
		jQuery('#menu_vousetes_small .dropdown dd').css('padding-top','initial');	
		jQuery('#menu_vousetes_small').css('line-height','1.4rem');	
		jQuery('#menu_vousetes_small .dropdown dt a').css('font-size','1rem');			
		//jQuery('#menu_vousetes_small .dropdown dd ul').css('top','2px');
		
		jQuery('.sb-search').css('height','3.5rem');	
		jQuery('.sb-search form#recherche_simple').css('line-height','3.5rem');	
		jQuery('.sb-icon-search').css('height','3.5rem');	
		//jQuery('.sb-search-input').css('height','3.5rem');	
		jQuery('.sb-search').css('line-height','');	
		
	}


});

//MODE LECTURE ZEN
jQuery('a.reader').show().click( function() {
	jQuery('#page_deco').removeAttr('style');
	jQuery('body').removeAttr('style');
	jQuery('#page_deco p').removeAttr('style');
	jQuery('#pretitre').css('overflow','hidden');
	if ( jQuery('body').hasClass('readerMode') ) {
		jQuery('#page_deco').fadeOut(0);
		if (jQuery('.article div.photo').length ) {
			jQuery('.article div.photo').css('width','auto');			
			jQuery('.article div.photo img').resizeToParent();
		}
		jQuery('header, #fil-ariane, #accroche, #navigation, .container-visuel-rubrique, #page_deco,  #container-plan-site, footer').fadeToggle(1000);

	}else {
		jQuery('header, #fil-ariane, #accroche, #navigation, .container-visuel-rubrique, #page_deco, #container-plan-site, footer').fadeToggle(1000);
	}
	jQuery('body').delay(1000).queue(function(){
		jQuery(this).toggleClass('readerMode');
		  if ( jQuery('body').hasClass('readerMode') ) {
				  jQuery('#page_deco').css('font-size','1.07rem');
				  jQuery('#page_deco').css('line-height','1.7rem');
				  jQuery('#page_deco').css('width','100%');
				  jQuery('#page_deco').css('max-width','42rem');
				  if (jQuery('body.article div.photo').length ) {
					jQuery('.fiche.article div.photo').css('width','42rem');			
					jQuery('body.article div.photo img').resizeToParent();
				  }
				  jQuery('#page_deco').fadeIn("slow");
				  jQuery('body').css('background','none');
			  }
		jQuery(this).dequeue();
	});
	if ( jQuery(this).text() == 'MODE LECTURE' || jQuery(this).text() == 'MODE SITE WEB' ) {
		jQuery(this).text(jQuery(this).text() == 'MODE LECTURE' ? 'MODE SITE WEB' : 'MODE LECTURE');
	} else if ( jQuery(this).text() == 'READER MODE' || jQuery(this).text() == 'WEB SITE MODE') {
		jQuery(this).text(jQuery(this).text() == 'READER MODE' ? 'WEB SITE MODE' : 'READER MODE');
	} else if ( jQuery(this).text() == 'MODO LECTURA' || jQuery(this).text() == 'MODO SITIO WEB') {
		jQuery(this).text(jQuery(this).text() == 'MODO LECTURA' ? 'MODO SITIO WEB' : 'MODO LECTURA');
	}
});
//RACCOURCI CLAVIER MODE ZEN + MODE DYSLEXIE + MODE CONTRASTE
var isCtrl = false;
jQuery(document).keydown(function(e){
	if (e.which == 17 || e.keyCode == 17){ 
		isCtrl = true; // si la touche G a été pressée
	}
	//Toutche escape on désactive
	if (e.which == 27 || e.keyCode == 27) { 
		if ( jQuery('body').hasClass('readerMode') ) { 
			jQuery('a.reader').trigger('click');
		}
		if ( jQuery('body').hasClass('dyslexic') ) {
			jQuery("body").toggleClass( "dyslexic" );
			jQuery.cookie( 'dyslexic', jQuery("body").hasClass( "dyslexic" ) , { path: '/' });
		}
		if ( jQuery('body').hasClass('contrast') ) {
			jQuery("body").toggleClass( "contrast" );
			jQuery.cookie( 'contrast', jQuery("body").hasClass( "contrast" ) , { path: '/' });
		}
	}
}).keyup(function(e){
	if (jQuery('input:focus').length > 0 || jQuery('textarea:focus').length > 0 || isCtrl != true)	{ 
		isCtrl = false; // Si on se trouve dans un input, une textarea ou si on n'a pas pressé la touche G, on ne peut pas faire des raccourcis clavier
		return false;
	}
	if (e.keyCode == true)		{
		var key = e.keyCode;
	} else {
		var key = e.which;
	}
	switch (key) {// On regarde la deuxième touche pressée par l'utilisateur
		// Ctrl + Enter
		case 13:
			jQuery('a.reader').trigger('click');
			return false;
		case 112:
			jQuery("body").toggleClass( "dyslexic" );
			jQuery.cookie( 'dyslexic', jQuery("body").hasClass( "dyslexic" ), { expires: 1, path: '/' } );
			return false;
		case 113:
			jQuery("body").toggleClass( "contrast" );
			jQuery.cookie( 'contrast', jQuery("body").hasClass( "contrast" ), { expires: 1, path: '/' } );
			return false;
			break;
	}
	isCtrl = false; // On réinitialise le booléen
	
	
	
});


if ( jQuery.cookie('dyslexic') == 'true'){
	jQuery("body").addClass( 'dyslexic' );
}

if (jQuery('a.dys').length ) {
	jQuery( "a.dys" ).click(function() {
		//alert("ok");
		jQuery("body").toggleClass( "dyslexic" );
		jQuery.cookie( 'dyslexic', jQuery("body").hasClass( "dyslexic" ), { expires: 7, path: '/' } );
	});	
}

if ( jQuery.cookie('contrast') == 'true'){
	jQuery("body").addClass( 'contrast' );
}	
	if (jQuery('a.contr').length ) {
	jQuery( "a.contr" ).click(function() {
		//alert("ok");
		jQuery("body").toggleClass( "contrast" );
		jQuery.cookie( 'contrast', jQuery("body").hasClass( "contrast" ), { expires: 7, path: '/' } );
	});	
}	


function transitionFor(e,p){
	jQuery(e).css('transition',p);
	jQuery(e).css('-webkit-transition',p);
	jQuery(e).css('-o-transition',p);
	jQuery(e).css('-ms-transition',p);
}

//Animation Chiffres clés
jQuery(window).scroll(startCounter);
function startCounter() {
	if (jQuery('#counter-container').length ) {
		let scrollY = (window.pageYOffset || document.documentElement.scrollTop) + window.innerHeight;
		let divPos = jQuery('#counter-container').offset().top;
		if (scrollY > divPos) {
		  jQuery(window).off("scroll", startCounter);
		  jQuery('.count').each(function() {
	      var jQuerythis = jQuery(this);
	      jQuery({
	        Counter: 0
	      }).animate({
	        Counter: jQuerythis.text().replace(/,/g, '')
	      }, {
	        duration: 2500,
	        easing: 'swing',
	        step: function() {
	        	jQuerythis.text(commaSeparateNumber(Math.floor(this.Counter)));
	        },
	        complete: function() {
	        	jQuerythis.text(commaSeparateNumber(this.Counter));
	          //alert('finished');
	        }
	      });
	    });
	    function commaSeparateNumber(num) {
	      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    }
	  }
	}
}